import React, { useState } from 'react'
import TextInput from '../../../../components/atoms/TextInput/TextInput'
import Button from '../../../../components/atoms/Button/Button'

export interface ResetPasswordRequestFormViewProps {
  handleSubmit: (email: string) => void;
  isLoading?: boolean;
  error?: string | null;
  isDone?: boolean;
}

export default function ResetPasswordRequestFormView({ 
  handleSubmit, 
  isLoading = false, 
  error,
  isDone = false
}: ResetPasswordRequestFormViewProps) {
  const [email, setEmail] = useState<string>('')
  const [emailError, setEmailError] = useState<string>('')

  const validateEmail = (email: string) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
    if (!email) {
      return 'L\'adresse email est requise'
    }
    if (!emailRegex.test(email)) {
      return 'Veuillez saisir une adresse email valide'
    }
    return ''
  }

  const handleFormSubmit = () => {
    const validation = validateEmail(email)
    setEmailError(validation)
    
    if (!validation) {
      handleSubmit(email)
    }
  }

  const handleEmailChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setEmail(e.target.value)
    if (emailError) {
      setEmailError('')
    }
  }

  if (isDone) {
    return (
      <div style={{ 
        maxWidth: '400px', 
        margin: '0 auto', 
        padding: '20px',
        textAlign: 'center'
      }}>
        <div style={{
          color: '#2e7d32',
          backgroundColor: '#e8f5e8',
          padding: '20px',
          borderRadius: '8px',
          fontSize: '16px',
          lineHeight: '1.5'
        }}>
          <h2 style={{ margin: '0 0 12px 0', color: '#2e7d32' }}>
            Email envoyé avec succès !
          </h2>
          <p style={{ margin: '0' }}>
            Veuillez vérifier votre boîte de réception et suivre les instructions pour réinitialiser votre mot de passe.
          </p>
        </div>
      </div>
    )
  }

  return (
    <div style={{ 
      maxWidth: '400px', 
      margin: '0 auto', 
      padding: '20px',
      display: 'flex',
      flexDirection: 'column',
      gap: '20px'
    }}>
      <div style={{ textAlign: 'center', marginBottom: '20px' }}>
        <h1 style={{ margin: '0 0 8px 0', fontSize: '24px', color: '#333' }}>
          Mot de passe oublié ?
        </h1>
        <p style={{ 
          margin: '0', 
          color: '#666', 
          fontSize: '14px',
          lineHeight: '1.5'
        }}>
          Saisissez votre adresse email et nous vous enverrons un lien pour réinitialiser votre mot de passe.
        </p>
      </div>

      {error && (
        <div style={{ 
          color: '#d32f2f', 
          backgroundColor: '#ffebee', 
          padding: '12px', 
          borderRadius: '4px',
          fontSize: '14px',
          border: '1px solid #ffcdd2'
        }}>
          {error}
        </div>
      )}

      <div>
        <TextInput
          label="Adresse email"
          value={email}
          onChange={handleEmailChange}
          placeholder="exemple@domaine.com"
          error={!!emailError}
          style={{ marginBottom: '8px' }}
          type="email"
        />
        {emailError && (
          <div style={{ color: '#d32f2f', fontSize: '12px', marginTop: '4px' }}>
            {emailError}
          </div>
        )}
      </div>

      <div style={{ marginTop: '20px' }}>
        <Button
          label={isLoading ? "Envoi en cours..." : "Envoyer le lien de réinitialisation"}
          onClick={handleFormSubmit}
          disabled={isLoading}
          variant="primary"
          isLoading={isLoading}
          height="48px"
        />
      </div>

      <div style={{ 
        fontSize: '12px', 
        color: '#666', 
        textAlign: 'center',
        marginTop: '16px',
        lineHeight: '1.4'
      }}>
        <p style={{ margin: '0' }}>
          Si vous n'avez pas de compte, contactez votre administrateur.
        </p>
        <p style={{ margin: '8px 0 0 0' }}>
          Le lien de réinitialisation sera valide pendant 24 heures.
        </p>
      </div>
    </div>
  )
}
